export default {
  lobbybanners: [],
  pagination: {},
  lobbybanner: {}
}
